import { useQuery } from '@tanstack/react-query';
import { ConsigneesApi } from 'api';

/**
 * Custom React Query hook to fetch consignee data by id
 *
 * @param {number} id
 * @param {{onError?: (error: Error) => void}} options
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useGetConsignee(id, { onError } = {}) {
  return useQuery({
    queryKey: ['consignee', id],
    queryFn: () =>
      ConsigneesApi.getById(id)
        .then((res) => res.data)
        .catch((error) => {
          typeof onError === 'function' && onError(error);
        }),
  });
}
